export const LinkItems = [
    {
        name: "Login",
        ref: "#",
        filled: false,
    },
    {
        name: "Sign Up",
        ref: "#",
        filled: true,
    },
];
